<template lang="pug">
div
  app-modal-visualizar-titulo(
    titulo="Visualizar Certidão"
    v-if="showModalVisualizarMinuta"
    @closeModal="showModalVisualizarMinuta = false"
    :bytes="bytes"
  )
  el-card.card-container(shadow="hover")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      el-row.filter-row
        el-col
          el-date-picker.full-width.input.date(
            type="daterange",
            start-placeholder="Data inicial",
            end-placeholder="Data Final",
            format="dd/MM/yyyy",
            name='dataCadastro',
            v-model="filtro.periodo",
            :style='{"width": "inherit"}'
          )

        el-col
          el-input.input(
            placeholder="Informe o número da certidão",
            v-model="filtro.campoSimples",
          )

      .button-group
          el-button.no-padding(
            type="text",
            @click="limpar"
          )    Limpar

          el-button(
            type="primary"
            @click="pesquisar"
          )
            i.fal.fa-search.iconColor
            | &nbsp Pesquisar

  app-listagem(
    tituloCard="Certidão de título"
    :hasActionButton="isEmissaoCertidao()"
    type="success",
    icon="fal fa-file",
    nameActionButton="Gerar Certidão"
    @click="emitirCertidao"
    :headerLabel="`Listagem das Certidões de Título do Processo ${numeroProcesso}`"
    :has-refresh-button="true",
    :showExportCsv="false",
    :showButtonOrdemServico="true",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    @updateListagem="refresh",
    :filtro="filtro",
    @changePage="changePage",
    @executar="executar",
    @selected="false",
    @sort="sort"
  )
  div.buttons-acoes
    app-button(
      tipo="default"
      :link="urlOrigem"
      titulo="Voltar"
      icone='fas fa-chevron-left'
      )

    el-button(
      :type="button.type",
      @click="button.action",
      :name="button.label",
      v-for="button in buttonsTarefas"
      :key="button.valor"
    )
      span.center
        i(v-if="button.icon" :class="button.icon" )
        b &nbsp {{button.label}}

    el-button(
      :type="confirmarButton.tipo",
      @click="confirmarButton.action",
      :name="confirmarButton.label",
      v-if="buttonsTarefas.length === 0"
    )
      span.center
        i(v-if="confirmarButton.class" :class="confirmarButton.class" )
        b &nbsp {{confirmarButton.label}}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarTitulo from '@/screens/analise/components/modal/AppModalVisualizarTitulo'
import Filtro from './Filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppButton from '@/components/AppButton'
import { cloneDeep } from 'lodash'
import statusProcesso from '@/utils/status'

const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

const FILTRO_EMPTY = {
  simples: true,
  ordem: 'id',
  ordemDirecao: 'DESC',
  pagina: 0,
  campoSimples: '',
  periodo: null,
  isHistorico: false
}

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarTitulo,
    AppButton
  },

  mixins: [BaseFiltro, AppNotificacao],

  data () {
    return {
      filtro: cloneDeep(FILTRO_EMPTY),
      items: [],
      bytes: null,
      totalElements: 0,
      numeroProcesso: null,
      tipo: null,
      showModalVisualizarMinuta: false,
      colunas: [
        {
          id: 0,
          titulo: 'Status',
          propriedade: 'tituloDespacho.tituloProcessoDTO.statusEntregaCertidao',
          ordem: 1,
          acoes: [],
          exibir: this.isAguardandoEntrega
        },
        {
          id: 0,
          titulo: 'Nº da Certidão',
          propriedade: 'tituloDespacho.tituloProcessoDTO.numeroDaCertidao',
          ordem: 1,
          acoes: []
        },
        {
          id: 1,
          titulo: 'Nº do Livro',
          propriedade: 'tituloDespacho.tituloProcessoDTO.numeroLivro',
          ordem: 2,
          acoes: []
        },
        {
          id: 2,
          titulo: 'CPF/CNPJ do Interessado',
          propriedade: 'processo.cpfCnpjInteressado',
          ordem: 3,
          acoes: []
        },
        {
          id: 3,
          titulo: 'Nome/Razão Social do Interessado',
          propriedade: 'processo.nomeRazaoSocialInteressado',
          ordem: 4,
          acoes: []
        },
        {
          id: 4,
          titulo: 'Data de expedição',
          propriedade: 'tituloDespacho.tituloProcessoDTO.dataEmissao',
          ordem: 5,
          acoes: []
        },
        {
          id: 5,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 6,
          acoes: [
            {
              id: 1,
              nome: 'Visualizar',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_CERTIDAO',
              ordem: 1,
              show: this.showVisualizarCertidao
            },
            {
              id: 2,
              nome: 'Excluir',
              icone: 'fa-trash',
              codigo: 'DELETE_CERTIDAO',
              ordem: 2,
              show: this.showExcluir
            },
            {
              id: 3,
              nome: 'Acusar Entrega',
              icone: 'fa-check',
              codigo: 'ACUSAR_ENTREGA',
              ordem: 1,
              show: this.isAguardandoEntrega
            }
          ]
        }
      ],
      usuario: null,
      confirmarButton: {
        label: 'Confirmar Dados',
        action: this.confirmarDados,
        tipo: 'success'
      },
      buttonsTarefas: [],
      tarefas: { acoes: [] }
    }
  },

  props: {
    idProcesso: {
      type: [Number, String]
    },
    urlOrigem: {
      default: 'EM_ANALISE',
      type: String
    },
    tarefa: {
      default: false,
      type: Boolean
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
    this.init()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      findByFilter: 'despacho/findByFilter',
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      criarNovaCertidao: 'despacho/criarNovaCertidao',
      deleteCertidao: 'despacho/deleteCertidao',
      getTarefa: 'processo/tarefa',
      finalizarEntregasCertidoes: 'despacho/finalizarEntregasCertidoes'
    }),

    async init () {
      this.tipo = this.$route.query.tipo
      this.items = await this.findByFilter({
        ...this.filtro,
        tipo: this.tipo,
        idProcesso: this.idProcesso
      })
      this.numeroProcesso = this.items[0].processo.numeroProcesso
      this.setAcao()
    },

    async pesquisar () {
      this.tipo = this.$route.query.tipo
      this.items = await this.findByFilter({
        ...this.filtro,
        tipo: this.tipo,
        idProcesso: this.idProcesso
      })
    },

    refresh () {
      this.init()
    },

    async emitirCertidao () {
      try {
        this.$router.push({
          name: 'continuar-emissao-titulo',
          params: {
            idProcesso: this.idProcesso,
            tipo: 'EMITIR_TITULO',
            urlOrigem: 'CERTIDAO_LISTAGEM'
          }
        })
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          `Erro tentar criar certidão, contate o administrador do sistema.`
        )
      }
    },

    async VISUALIZAR_CERTIDAO (_this, { item }) {
      const arraybufferTitulo = await this.getArrayTituloByDespachoId(item.id)
      this.bytes = arraybufferTitulo
      this.showModalVisualizarMinuta = true
    },

    async DELETE_CERTIDAO (_this, { item }) {
      try {
        this.confirmBox(
          this.$messages.DOCUMENTO_REMOVE_CONFIRM,
          this.$messages.TITULO_WARNING,
          async () => {
            await this.deleteCertidao(item.id)
            this.refresh()
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              `Certidão excluída com sucesso.`
            )
          },
          () => {}
        )
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          `Erro ao excluir certidão, contate o administrador do sistema.`
        )
      }
    },

    async confirmarDados () {
      this.$router.push({
        name: 'CONFIRMAR_DADOS',
        params: {
          idProcesso: this.idProcesso
        }
      })
    },

    sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      this.pesquisar()
    },

    limpar () {
      this.filtro = cloneDeep(FILTRO_EMPTY)
      this.refresh()
    },

    isEmissaoCertidao () {
      return (
        this.items[0]?.processo.status === statusProcesso.EM_EMISSAO_CERTIDAO
      )
    },

    isAguardandoEntrega (item) {
      return (
        this.items[0]?.processo.status === statusProcesso.AGUARDANDO_ENTREGA &&
        !item?.tituloDespacho?.tituloProcessoDTO?.entregue
      )
    },

    showVisualizarCertidao (despacho) {
      return despacho.tipo === 'TITULO_CERTIDAO'
    },

    showExcluir () {
      return this.isEmissaoCertidao()
    },

    async setAcao () {
      if (!this.isEmissaoCertidao()) {
        this.tarefas = await this.getTarefa({ processo: this.idProcesso })
      }
      if (this.tarefas.acoes.length > 0) {
        this.buttonsTarefas = this.tarefas.acoes
          .map(acao => {
            return {
              label: acao.nome,
              action: () =>
                this.finalizar({
                  acao: acao.valor,
                  processoId: this.idProcesso
                }),
              type: 'success',
              id: acao.valor
            }
          })
          .reverse()
      }
    },

    async finalizar (dados) {
      try {
        await this.finalizarEntregasCertidoes(dados)
        this.$router.push({
          name: 'TITULO_CERTIDAO'
        })
      } catch (e) {}
    },

    ACUSAR_ENTREGA: (_this, { item }) => {
      _this.$router.push({
        name: 'ACUSAR_ENTREGA',
        params: {
          idProcesso: item.processo.id,
          idDespacho: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.buttons-acoes {
  margin: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin: 1%;
  button:nth-child(1) {
    font-size: 15px;
    padding: 6px;
  }
  button:nth-child(2) {
    font-size: 12px;
    padding: 7px;
  }
}

.filter-row {
  display: flex;
  gap: 1%;
}

>>> .el-table th > .cell {
  align-items: center;
}

h1 {
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CertidaoListagem.vue